module.exports = __webpack_public_path__ + "static/media/payjak-picturemark-d.009df52e.svg";